
  // Дистанции для интервалов
export const intervalDistances = [
    { key: '200m', label: '200m' },
    { key: '300m', label: '300m' },
    { key: '400m', label: '400m' },
    { key: '600m', label: '600m' },
    { key: '800m', label: '800m' },
    { key: '1000m', label: '1000m' },
    { key: '1200m', label: '1200m' },
  ];

export const DISTANCE_PRESETS = [
  { value: 5000, label: '5000 (5K)' },
  { value: 10000, label: '10000 (10K)' },
  { value: 21097, label: '21097 (HM)' },
  { value: 42195, label: '42195 (Marathon)' },
];